import React from 'react';
import PdfPage from './PdfPage';

// pageIndex: 0이면 제목+본문(p04--b 2컬럼), 1+이면 본문만 전체폭(p04--a)
function PdfDescription({ data, officeName, dateLabel, pageIndex = 0 }) {
  const paragraphs = data.paragraphs || (data.body || '').split('\n').filter(Boolean);

  if (pageIndex === 0) {
    return (
      <PdfPage officeName={officeName} pageLabel="Property Report" dateLabel={dateLabel} className="p04--b">
        <div className="p04__band">
          <span className="p04__chapter">매물 설명</span>
        </div>
        <div className="p04__body">
          <header className="p04__head">
            <h2 className="p04__title">{data.title}</h2>
          </header>
          <div className="prose">
            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      </PdfPage>
    );
  }

  // 이어지는 페이지: 전체 폭(p04--a) 사용
  return (
    <PdfPage officeName={officeName} pageLabel="Property Report" dateLabel={dateLabel} className="p04--a">
      <div className="p04__band">
        <span className="p04__chapter">매물 설명 (이어서)</span>
      </div>
      <div className="p04__body">
        <div className="prose">
          {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </PdfPage>
  );
}

export default PdfDescription;
